import React from 'react'
import { Form, Input, message } from 'antd'
import { postArtistContact } from '../../api/artistPartnerProfile'
import HttpError from '../base/HttpError'

class PartnerProfileAddContactForm extends React.Component {
  constructor(props) {
    super(props)
    this.artistId = props.artistId
    this.formId = props.formId ? props.formId : 'partner-profile-add-contact-form'
    this.onFinishSubmit = props.onFinishSubmit
    this.disabled = false
  }

  onFinish = (values) => {
    if (this.disabled) return
    this.disabled = true
    values['artist'] = this.artistId
    postArtistContact(values)
      .then((res) => {
        message.success('Add a contact info successfully').then((v) => {})
        if (this.onFinishSubmit) {
          this.onFinishSubmit(res.data)
        }
      })
      .catch((error) => {
        HttpError(error)
      })
      .finally(() => {
        this.disabled = false
      })
  }

  onFinishFailed = ({ values, errorFields, outOfDate }) => {
    this.setState({ validateError: errorFields })
    window.scrollTo(0, 0)
    window.scrollTop = 0
  }

  render() {
    return (
      <Form
        id={this.formId}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 16, offset: 2 }}
        colon={false}
        onFinish={this.onFinish}
        onFinishFailed={this.onFinishFailed}
      >
        <Form.Item
          name='first_name'
          label='First name'
          rules={[
            {
              required: false,
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='last_name'
          label='Last name'
          rules={[
            {
              required: false,
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='job_title'
          label='Job title'
          rules={[
            {
              required: false,
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='email'
          label='Email'
          rules={[
            {
              required: false,
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='phone_number'
          label='Phone number'
          rules={[
            {
              required: false,
              type: 'string',
              max: 100,
              min: 1
            }
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    )
  }
}

export default PartnerProfileAddContactForm
